export default __webpack_public_path__ + "static/media/gold.3ea6374cf1549a8328626811a135ab5f.svg";